import CreateOrganizationModal from './ui/CreateOrganizationModal';

export default CreateOrganizationModal;
